export const phobioSelector = (state) => state.phoneReducer.phobioDetails;
export const phonesCountSelector = (state) => state.phoneReducer.phonesCount;
